import common from './common';
import layout from './layout';
import login from './login';
import robotDevice from './robotDevice';
import robotDogDevice from './robotDogDevice';
import robotTask from './robotTask';
import robotPiano from './robotPiano';
import largeScreen from './largeScreen';
import robotDogMap from './robotDogMap';
import alarmCenter from './alarmCenter';
import robotDogLiveStream from './robotDogLiveStream';
import robotTernDetail from './robotTernDetail';
import robotDogInspectionReport from './robotDogInspectionReport';
import robotDogMediaCenter from './robotDogMediaCenter';
import product from './product';
import mapDetail from './mapDetail';
import inspectionCollaboration from './inspectionCollaboration';
import inspectionAssistant from './inspectionAssistant';
import media from './media';
import algorithm from './algorithm';
import tsa from './tsa';
import gMap from './gMap';
import livestream from './livestream';
import audio from './audio';
import task from './task';
import wayline from './wayline';
import dock from './dock';
import binding from './binding';
import llmImage from './llmImage';
import label from './label';
import config from './config';
import enumManagement from './enumManagement';
import productConfig from './productConfig';
import deviceAlgorithm from './deviceAlgorithm';
import model from './model';
import video from './video';
import topic from './topic';
import role from './role';
import user from './user';
import deviceList from './deviceList';
import scenarioModel from './scenarioModel';
import dict from './dict';
import device from './device';
import firmware from './firmware';
import menu from './menu';
import notFound from './notFound';
import groundAir from './groundAir';
import routeNames from './routeNames';
import annotation from './annotation';
import materialApply from './materialApply';
import warehouseMonitor from './warehouseMonitor';
import jobOverview from './jobOverview';
import taskList from './taskList';
import taskDetail from './taskDetail';
import dispatch from './dispatch';
import materialLib from './materialLib';
import stationList from './stationList';
import hcScreen from './hcScreen';
import termDetail from './termDetail';

/** 按业务模块拆分；新页面在对应文件加 key，未迁移页面可继续硬编码中文 */
export default {
  ...routeNames,
  materialApply,
  warehouseMonitor,
  jobOverview,
  taskList,
  taskDetail,
  dispatch,
  materialLib,
  stationList,
  hcScreen,
  termDetail,
  common,
  layout,
  login,
  robotDevice,
  robotDogDevice,
  robotTask,
  robotPiano,
  largeScreen,
  robotDogMap,
  alarmCenter,
  robotDogLiveStream,
  robotTernDetail,
  robotDogInspectionReport,
  robotDogMediaCenter,
  product,
  mapDetail,
  inspectionCollaboration,
  inspectionAssistant,
  media,
  algorithm,
  tsa,
  gMap,
  livestream,
  audio,
  task,
  wayline,
  dock,
  binding,
  llmImage,
  label,
  config,
  enumManagement,
  productConfig,
  deviceAlgorithm,
  model,
  video,
  topic,
  role,
  user,
  deviceList,
  scenarioModel,
  dict,
  device,
  firmware,
  menu,
  notFound,
  groundAir,
  annotation,
};
